import { ShieldCheck, Layers, Users, Coffee } from "lucide-react";
import { fmt, levelName } from "@/lib/ratings";

function Tag({ children, warn, testid }) {
  return (
    <span data-testid={testid} className="text-[10px] mono uppercase tracking-wider rounded-full px-2 py-0.5"
      style={warn ? { background: "rgba(245,158,11,0.15)", color: "#f59e0b" } : { background: "rgba(168,230,0,0.16)", color: "var(--primary-ink)" }}>
      {children}
    </span>
  );
}

function Tile({ icon: Icon, title, value, sub, tag, big, testid }) {
  return (
    <div className={`rounded-2xl glow-border p-5 ${big ? "sm:col-span-2" : ""}`} style={{ background: "var(--surface)" }} data-testid={testid}>
      <div className="flex items-center gap-2 text-[11px] uppercase tracking-[0.2em] font-bold" style={{ color: "var(--text-2)" }}>
        <Icon className="w-4 h-4 text-primary-c" /> {title}
      </div>
      <div className="flex items-end gap-3 mt-3 flex-wrap">
        <span className={`font-display font-black tabular-nums ${big ? "text-5xl" : "text-3xl"}`} data-testid={`${testid}-value`}>{fmt(value)}</span>
        {value != null && <span className="font-display font-bold text-sm pb-1 text-primary-c" data-testid={`${testid}-level`}>{levelName(value)}</span>}
        {tag}
      </div>
      <p className="text-xs mt-2 leading-relaxed" style={{ color: "var(--text-2)" }}>{sub}</p>
    </div>
  );
}

export default function RatingHierarchy({ official, assessment, composite, casual }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-5 gap-4" data-testid="rating-hierarchy">
      <Tile big icon={ShieldCheck} title="Official Performance Rating" value={official.rating} testid="official-rating"
        tag={official.rating == null ? <Tag warn testid="official-status">Unrated</Tag> : null}
        sub={`Primary competitive rating from ${official.matches} verified match result${official.matches === 1 ? "" : "s"} (0.0–6.0+). Updates after every event. Community opinions never change it.`} />
      <Tile icon={Layers} title="Composite" value={composite.rating} testid="composite-rating" sub={`Optional. ${composite.formula}.`} />
      <Tile icon={Users} title="Assessment" value={assessment.rating} testid="assessment-rating"
        tag={assessment.rating != null && assessment.provisional ? <Tag warn testid="assessment-status">Incomplete</Tag> : null}
        sub="50% Organizer + 30% Event Participants + 20% Acquaintances." />
      <Tile icon={Coffee} title="Casual Play" value={casual?.rating} testid="casual-rating"
        sub={casual?.count ? `${casual.count} rating${casual.count === 1 ? "" : "s"} from ${casual.sessions} Open Play session${casual.sessions === 1 ? "" : "s"}. Separate from Assessment.` : "From players in published Open Play sessions. Separate from Assessment."} />
    </div>
  );
}
